const SECOND_MS = 1000
const MINUTE_SECONDS = 60
const HOUR_SECONDS = 60 * MINUTE_SECONDS
const DAY_SECONDS = 24 * HOUR_SECONDS

export const formatMdfSyncTime = (syncTime: number, now: number = Date.now()) => {
  const elapsedSeconds = Math.max(0, Math.floor((now - syncTime) / SECOND_MS))
  const days = Math.floor(elapsedSeconds / DAY_SECONDS)
  const hours = Math.floor((elapsedSeconds % DAY_SECONDS) / HOUR_SECONDS)
  const minutes = Math.floor((elapsedSeconds % HOUR_SECONDS) / MINUTE_SECONDS)

  if (days > 0) {
    return [`${days}d`, hours > 0 ? `${hours}h` : '', minutes > 0 ? `${minutes}m` : '']
      .filter(Boolean)
      .join(' ')
  }

  if (hours > 0) {
    return [`${hours}h`, minutes > 0 ? `${minutes}m` : ''].filter(Boolean).join(' ')
  }

  if (minutes > 0) {
    return `${minutes}m`
  }

  return `${elapsedSeconds}s`
}
